export default "__VITE_ASSET__DKy$1cI5__"